import React from "react";
import { RouteComponentProps } from "react-router-dom";

interface MatchParams {
  id: string;
}

export const System = ({
  history,
  match
}: RouteComponentProps & RouteComponentProps<MatchParams>) => {
  return <h2>System Data: {match.params.id}</h2>;
};
